module.exports = __webpack_public_path__ + "img/hadi_mouth.64eb2fdb.jpg";